import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'name',
  standalone: false
})
export class NamePipe implements PipeTransform {

  transform(email: string, format: string): string {
    switch (format) {
      case 'name':
        return email.match(new RegExp('^[a-zA-Z\-]+'))?.toString() ?? '';
      case 'surname':
        return email.match(new RegExp('(?<=\\.)[a-zA-Z\\-]+(?=@)'))?.toString() ?? '';
      default:
        return '';
    }
  }

}
